import React, { useEffect, useState } from "react";
import Header from "./components/Header";
import AmbientBackground from "./components/AmbientBackground";
import CustomCursor from "./components/CustomCursor";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import CertificatesPage from "./pages/CertificatesPage";
import ProjectPage from "./pages/ProjectsPage";
import ContactPage from "./pages/ContactsPage";
import ContactModal from "./components/ContactModal";
import "./assets/css/style.css";

function App() {
  const [showBackToTop, setShowBackToTop] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("revealed");
          }
        });
      },
      { threshold: 0.06, rootMargin: "0px 0px -50px 0px" }
    );

    const revealElements = document.querySelectorAll(".reveal");
    revealElements.forEach((el) => observer.observe(el));

    // Handle back to top button visibility (appear when scrolled > 30% viewport)
    const handleScroll = () => {
      if (window.scrollY > window.innerHeight * 0.3) {
        setShowBackToTop(true);
      } else {
        setShowBackToTop(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      revealElements.forEach((el) => observer.unobserve(el));
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="App">
      <CustomCursor />
      <AmbientBackground />
      <Header />
      <main className="main-content">
        <HomePage />
        <AboutPage />
        <CertificatesPage />
        <ProjectPage />
        <ContactPage />
      </main>

      {/* Floating Action Button & Contact Modal */}
      <ContactModal />

      {/* Back to Top Button */}
      {showBackToTop && (
        <button 
          className="back-to-top" 
          onClick={scrollToTop} 
          aria-label="Back to top"
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="18 15 12 9 6 15"></polyline>
          </svg>
        </button>
      )}
    </div>
  );
}

export default App;
